import { createStore } from "vuex";

import admin from "./admin";
import briefing from "./briefing";
import menuList from "./menuList";

const store = createStore({
  modules: {
    admin,
    briefing,
    menuList
  },
});

export default store;
